export function normalizeLegacyHashUrl(): void {
    const { hash, pathname, search } = window.location;
    const isLegacyHashRoute = hash.startsWith('#/');

    const rawUrl = isLegacyHashRoute ? hash.slice(1) : `${pathname}${search}`;
    
    if (isLegacyHashRoute) {
        history.replaceState(null, '', rawUrl);
    }
}